import { Outlet, useParams } from "react-router-dom";
import { Box, Button, CircularProgress, Grid } from "@mui/material";
import { useLiveResolver } from "../../hooks/useLiveResolver.js";
import { useActuIdMapping } from "../../hooks/useActuIdMapping.js";
import { useEffect } from "react";
import { useNavigateTo } from "../../hooks/useNavigateTo.js";
import { CALENDAR_MODE } from "./constants/MODE_LIST.js";
import LiveExport from "../../../components/Live/LiveExport.js";
import DsasButton from "../../components/DsasButton/DsasButton.js";
import { faMicrophoneLines } from "@fortawesome/free-solid-svg-icons";

const DirectActuDetailResolver = () => {

    const { id } = useParams();
    const navigateTo = useNavigateTo()
    const [live] = useLiveResolver(id, CALENDAR_MODE, 0, undefined)

    console.log("Actu detail resolver ", live)

    const [actuIdMapping, getIdActuFromActuName] = useActuIdMapping(live)

    useEffect(() => {
        if (live && live.actualitesDetails && live.actualitesDetails.length === 1) {
            const actuId = live.actualites[0]; // Récupérer l'ID du seul match disponible
            navigateTo(`${actuIdMapping[actuId]}`); // Ajouter l'ID du match à l'URL
        }
    }, [navigateTo, live, actuIdMapping]);

    const handleOpenLive = () => {
        let urlLocation = undefined
        //On récupère l'url de live
        if(process.env.NODE_ENV === 'development'){
          urlLocation = 'http://localhost:3006';
        }else{
          urlLocation = process.env.REACT_APP_LIVE_CLIENT_URL;
        }
  
        const url = urlLocation + "/actualite/"+id 
  
        window.open(url, '_blank', 'toolbar=0,location=0,menubar=0');
    }

    // console.log(live)

  
  
    if(!live || !Object.keys(live).length)
        return <CircularProgress/>



    return  <>
                <Box className='centered-medium-wrapper'>
                    <h1 className='page-title'>Direct Actu</h1>
                </Box>
                <Box className='medium-separator'></Box>
                <Box className='padding-wrapper'>
                  <Grid container>
                      <Grid item alignSelf={"flex-start"} xs={6} sm={3} md={2}>
                        {/*Bouton Ouvrir le direct*/}
                        <DsasButton icon={faMicrophoneLines} label="Ouvrir le direct" variant = 'secondary' onClick={handleOpenLive} />
                      </Grid>
                      <Grid item xs={1} sm={6} md={8}>
                      </Grid>
                      <Grid item alignSelf={"flex-end"} xs={5} sm={3} md={2}>
                        {/*Bouton Export*/}
                        <Box sx={{display:"grid"}}>
                          <Box sx={{justifySelf:"right"}}><LiveExport idLive={id} isActu={true} live={live}/></Box>
                        </Box>
                      </Grid>
                  </Grid>

                  <Box className="small-padding"></Box>
                   
                  <Outlet context={{live, actuIdMapping, getIdActuFromActuName}}/>

                </Box>
    </>;
    
};
export default DirectActuDetailResolver